import React from 'react';
import diagram from '../../assets/flow-diagram-2.jpg';

function FlowDiagram2() {
    return (
        <>
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="flex justify-start">
                    <div className="max-w-[250px]">
                        <p>COMSAR/Circ.25</p>
                        <p>ANNEX</p>
                        <p>Page 4</p>
                    </div>
                </div>
                <h3 className="uppercase font-medium text-center text-sm">
                    Flow Diagram 2
                </h3>
                <img
                    src={diagram}
                    className="h-[400px]"
                    height={'400px'}
                    alt="Flow Diagram 2"
                />

                <div>
                    <h2 className="text-sm font-bold text-gray-800 mb-4">
                        REMARKS:
                    </h2>

                    <div className=" text-gray-700">
                        <div className="pl-4">
                            <div className="flex gap-x-2 ">
                                <div className=" w-[120px]">
                                    <strong>Note 1:</strong>
                                </div>
                                <span>
                                    If it is clear the ship or persons in
                                    distress are not in the vicinity and/or
                                    other crafts are better placed to assist,
                                    superflous communications which could
                                    interfere with search and rescue activities
                                    are to be avoided. Details should be
                                    recorded in the appropriate logbook
                                </span>
                            </div>
                        </div>
                        <div className="pl-4">
                            <div className="flex gap-x-2 ">
                                <div className="w-[60px]">
                                    <strong>Note 2:</strong>
                                </div>
                                <span>
                                    The ship should establish communications
                                    with the station controlling the distress as
                                    directed and render such assistance as
                                    required and appropriate.
                                </span>
                            </div>
                        </div>
                        <div className="pl-4">
                            <div className="flex gap-x-2 ">
                                <div className="w-[60px]">
                                    <strong>Note 3:</strong>
                                </div>
                                <span>
                                    Distress relay calls should be initiated
                                    manually.{' '}
                                </span>
                            </div>
                        </div>

                        {/* Legend */}
                        <div className=" pt-2 mt-2">
                            <p className="text-sm text-gray-600 font-semibold text-center flex justify-center items-center gap-x-8">
                                <span>CS = Coast Station</span>
                                <span>RCC = Rescue Co-ordination Center</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FlowDiagram2;
